<template>
	<div class="question-container" style="border: 1px solid #edeff2">
		<div class="question-type">图片上传</div>
		<div class="title-view" :style="{ marginRight: '' }">
			<p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ `${index + 1}、` }}
				<span style="color: #4c4a56">
					{{ `${dataObj.caseProblem}` }}
				</span>
			</p>
		</div>

		<div class="question-images">
			<div v-for="(item, idx) in images" :key="idx" style="margin-top: 10px; position: relative">
				<img :src="item" mode="widthFix" style="width: 100%" />
			</div>
		</div>

		<div class="answer-images" v-if="answerImages.length">
			<div v-for="(img, idx) in answerImages" :key="'answer-' + idx" style="margin-top: 10px; position: relative">
				<img :src="img" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			params: {
				type: Object,
				default: {},
			},
		},
		data() {
			return {
				dataObj: {},
				index: 0,
				images: [],
				answerImages: [],
			};
		},
		watch: {
			params: {
				handler(newVal) {
					this.dataObj = newVal.data;
					this.index = newVal.index;
					this.images = JSON.parse(newVal.data.caseProblemImg || '[]');

					if (newVal.answer && Array.isArray(newVal.answer.answer)) {
						this.answerImages = newVal.answer.answer
							.map(item => item.context)
							.filter(Boolean);
					} else {
						this.answerImages = [];
					}
				},
				deep: true,
				immediate: true,
			},
		},
	};
</script>

<style scoped>
	.answer-images {
		display: flex;
		align-items: center;
		gap: 10px;
	}
	.answer-images img {
		width: 80px;
		height: 80px;
		border-radius: 4px;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewImage.vue